export default function (value) {
  const word = /[\u4E00-\u9FA5\uF900-\uFA2D\u00B7]/
  const doubleDot = /\u00B7\u00B7/
  const dot = /\u00B7/

  if (value === '') {
    return false
  }
  // 前后是点, 连续的点
  if (dot.test(value[0]) 
    || dot.test(value[value.length - 1])
    || doubleDot.test(value)) {
    return false
  } else {
    for (let i = 0, len = value.length; i < len; i++) {
      if (!word.test(value[i])) {
        return false
      }
    }
  }

  return true
}